import CompraService from "@/services/CompraService";

export const compra = {
  namespaced: true,
  state: {
    compra: {},
  },
  actions: {
    getCompra({ commit }, payload) {
      return CompraService.GetCompra(payload).then(
        (compra) => {
          return Promise.resolve(compra);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCompra({ commit }, payload) {
      return CompraService.PostCompra(payload).then(
        (compra) => {
          return Promise.resolve(compra);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCompra({ commit }, payload) {
      return CompraService.PutCompra(payload).then(
        (compra) => {
          return Promise.resolve(compra);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCompra({ commit }, payload) {
      return CompraService.DeleteCompra(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCompraOData({ commit }, payload) {
      return CompraService.GetCompraOData(payload).then(
        (compra) => {
          return Promise.resolve(compra);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    importarXML({ commit }, payload) {
      return CompraService.ImportarXML(payload).then(
        (compra) => {
          return Promise.resolve(compra);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    upload({ commit }, payload) {
      return CompraService.Upload(payload).then(
        (compra) => {
          return Promise.resolve(compra);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRelatorio({ commit }, payload) {
      return CompraService.GetRelatorio(payload).then(
        (compra) => {
          return Promise.resolve(compra);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    confirmarImportacao({ commit }, payload) {
      return CompraService.ConfirmarImportacao(payload).then(
        (compra) => {
          return Promise.resolve(compra);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default compra;
